import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HoverMenu, { HoverMenuContainer } from './hover-menu';

import { colors } from '../theme';
import MenuContents from './menu-contents-v2';

import { MIN_WIDTH_HOMEPAGE_DESKTOP, MIN_WIDTH_DESKTOP } from '../header-v2';
import GetQuotesButton from './get-quotes-button';
import HamburgerMenu from './header-menu-v2';

//show on desktop and tablet - mobile view has the login menu options in main mobile menu
const DesktopHoverMenu = styled(HoverMenu)`
  display: none;

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    display: inline-block;
    padding-right: 20px;

    ${HoverMenuContainer}:before, ${HoverMenuContainer}:after {
      left: 130px;
    }
  }
`;

const UsernameLink = styled.a`
  font-size: 15px;
  color: #333;
  text-decoration: none;
  color: ${colors.MEDIUM_DARK_GREY};
  display: inline-block;
  cursor: pointer;

  &:hover,
  &:visited {
    color: #555;
  }
`;

const Avatar = styled.img`
  border-radius: 100%;
  width: 26px;
  height: 26px;
  vertical-align: middle;
  cursor: pointer;
`;

const UnreadMessagesCircle = styled.span`
  position: absolute;
  top: -6px;
  width: 13px;
  height: 13px;
  right: -4px;
  display: block;
  margin: 0;
  background-color: ${props => props.theme.danger};
  border: 2px solid ${colors.WHITE};
  border-radius: 100%;
`;

export const HeaderGQButton = styled.div`
  display: none;

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    display: inline-block;
    padding-right: 22px;
  }
`;

export default class LoggedIn extends Component {
  static propTypes = {
    number_messages: PropTypes.number,
    username: PropTypes.string,
    user_thumbnail: PropTypes.string,
    isHomepage: PropTypes.bool,
    siteSource: PropTypes.string,
    loginData: PropTypes.object
  };

  render() {
    const { isHomepage, siteSource, loginData } = this.props;
    const [firstName] = (loginData.username || '').split(' ');
    return (
      <div style={{ float: 'right' }}>
        <DesktopHoverMenu
          fancyArrow={true}
          isHomepage={isHomepage}
          menuItem={
            <UsernameLink isHomepage={isHomepage}>
              <div style={{ position: 'relative', display: 'inline', marginRight: '10px' }}>
                <Avatar
                  src={`//avatar.homeimprovementpages.com.au/creative/users/${
                    loginData.user_thumbnail
                  }/140x140.jpg`}
                />
                {loginData.number_messages > 0 && <UnreadMessagesCircle />}
              </div>
              {firstName.length <= 17 && (
                <span style={{ marginRight: '10px' }}>{firstName}</span>
              ) /*Long firstnames break responsive, just dont show if over 17 chars */}
            </UsernameLink>
          }
        >
          <MenuContents siteSource={siteSource} loginData={loginData} />
        </DesktopHoverMenu>

        <HamburgerMenu loginData={loginData} isHomepage={isHomepage} siteSource={siteSource} />

        <HeaderGQButton isHomepage={isHomepage}>
          <GetQuotesButton siteSource={siteSource}>Get Quotes</GetQuotesButton>
        </HeaderGQButton>
      </div>
    );
  }
}
